import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface FavoritesState {
  favoriteProductLength: number;
  favoriteDesignLength: number;
}

const initialState: FavoritesState = {
  favoriteProductLength: 0,
  favoriteDesignLength: 0,
};

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    setProductLength: (state, action: PayloadAction<number>) => {
      state.favoriteProductLength = action.payload;
    },
    setDesignLength: (state, action: PayloadAction<number>) => {
      state.favoriteDesignLength = action.payload;
    },
  },
});

export const { setProductLength, setDesignLength } = favoritesSlice.actions;

export default favoritesSlice.reducer;
